/* global axios */
import ApiClient from '../ApiClient';

class TiktokShopChannel extends ApiClient {
  constructor() {
    super('tiktokshop', { accountScoped: true });
  }

  create(params) {
    return axios.post(
      `${this.url.replace(this.resource, '')}callbacks/register_tiktok_shop`,
      params
    );
  }
}

export default new TiktokShopChannel();
